export class PriceQueueModel {
    idCampaign: number;
    institution: string;
    serviceContract: number;
}